import { Container, Spacer } from '@chakra-ui/react';
import useAccountIdQueryParam from 'hooks/modules/brokerAccount/useAccountIdQueryParam';
import usePeriodQueryParam from 'hooks/modules/period/usePeriodQueryParam';
import NoAccountsCard from 'presentation/components/modules/portfolio/NoAccountsCard';
import PortfolioAnalyticsContainer from 'presentation/containers/modules/portfolio/PortfolioAnalyticsContainer';
import PortfolioChartContainer from 'presentation/containers/modules/portfolio/PortfolioChartContainer';
import PortfolioOpenedPositionsContainer from 'presentation/containers/modules/portfolio/PortfolioOpenedPositionsContainer';
import PortfolioDealsHistoryContainer from 'presentation/containers/modules/portfolio/PortfolioDealsHistoryContainer';
import PortfolioOperationsContainer from 'presentation/containers/modules/portfolio/PortfolioOperationsContainer';
import PortfolioPageLayout from 'presentation/layout/modules/portfolio/PortfolioPageLayout';
import PageLayout from 'presentation/layout/shared/page/PageLayout';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AppRoute from 'router/AppRoute';
import { useFetchPortfolioQuery } from 'rtkQuery/sharespro/queries/portfolio';
import WithdrawalRequestCard from 'presentation/components/modules/withdraal/WithdrawalRequestCard';
import InvestorServiceAutofollowCard from 'presentation/components/modules/portfolio/InvestorServiceAutofollowCard';

const PortfolioPage: FC = () => {
  const { t } = useTranslation();

  const [period] = usePeriodQueryParam();
  const [accountId] = useAccountIdQueryParam();
  const { data, refetch } = useFetchPortfolioQuery({
    period,
    account_id: accountId,
  });

  const selectedAccount = data?.accounts.items.find(
    (item) => item.id === accountId
  );

  if (data?.accounts.items.length === 0) {
    return (
      <PageLayout>
        <Container>
          <NoAccountsCard />
        </Container>
      </PageLayout>
    );
  }

  return (
    <PortfolioPageLayout>
      <PortfolioChartContainer
        isReportable={selectedAccount?.isReportable ?? false}
        id={selectedAccount?.id ?? -1}
      />
      <Spacer h="20px" />
      {selectedAccount &&
      (selectedAccount.service.isStoppable || selectedAccount.service.isResumable) ? (
        <InvestorServiceAutofollowCard
          account={selectedAccount}
          onSuccess={() => {
            refetch();
          }}
        />
      ) : null}
      <Spacer h="20px" />
      {selectedAccount &&
      (selectedAccount.service.isAllowWithdraw || selectedAccount.hasWithdrawRequest) ? (
        <WithdrawalRequestCard account={selectedAccount} />
      ) : null}
      <Spacer h="20px" />
      <PortfolioAnalyticsContainer />
      <Spacer h="20px" />
      <PortfolioOperationsContainer
        gridHeadingLink={{
          path: AppRoute.operations({
            account_id: accountId,
          }),
          text: t('moreDetails'),
        }}
      />
      <Spacer h="20px" />
      <PortfolioOpenedPositionsContainer />
      <Spacer h="20px" />
      <PortfolioDealsHistoryContainer
        limit={10}
        gridHeadingLink={{
          path: AppRoute.dealsHistory({
            account_id: accountId,
          }),
          text: t('moreDetails'),
        }}
      />
    </PortfolioPageLayout>
  );
};

export default PortfolioPage;
